import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import '../student/Newstudent.css';

function EditLocatie() {
  const navigate = useNavigate();
  const { id } = useParams();
  const token = sessionStorage.getItem('jwtToken');

  const [isLoading, setIsLoading] = useState(true);
  const [userStatus, setUserStatus] = useState(null);
  const [userRole, setUserRole] = useState(null);

  const [values, setValues] = useState({
    location_name: '',
    address: '',
    phone: '',
    email: '',
    contact_firstname: '',
    contact_lastname: '',
    contact_mobile: '',
  });

  const [emailExists, setEmailExists] = useState(false);

  const fetchUserLoginData = useCallback(
    async (email) => {
      if (!email) {
        setUserStatus('Geen waarde');
        setUserRole('Geen waarde');
        return;
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/auth/logindata/${email}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.status === 204) {
          setUserStatus('Geen waarde');
          setUserRole('Geen waarde');
        } else if (response.status === 200) {
          setUserStatus(response.data.status || 'Geen waarde');
          setUserRole(response.data.role || 'Geen waarde');
        } else {
          console.error('Unexpected response status:', response.status);
          setUserStatus('Error fetching data');
          setUserRole('Error fetching data');
        }
      } catch (error) {
        console.error('Error fetching user login data:', error);
        setUserStatus('Fout');
        setUserRole('Fout');
      }
    },
    [token]
  );

  const fetchLocation = useCallback(() => {
    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_BACKEND_URL}/location/getlocation/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        const locationData = response.data.data || {};
        setValues(locationData);
        setIsLoading(false);
        fetchUserLoginData(locationData.email);
      })
      .catch((error) => {
        console.error('Error fetching location data', error);
        setIsLoading(false);
      });
  }, [id, token, fetchUserLoginData]);

  useEffect(() => {
    fetchLocation();
  }, [fetchLocation]);

  const handleEmailBlur = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/check-email-existence`,
        {
          params: { email: values.email },
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setEmailExists(
        response.data.exists &&
          String(response.data.location_id) !== String(id)
      );
    } catch (error) {
      console.error('Error checking email existence:', error);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (emailExists) {
      alert('Het e-mailadres bestaat al in het systeem.');
      return;
    }

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_BACKEND_URL}/location/updatelocation/${id}`,
        values,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.status === 'success') {
        navigate('/locaties');
      } else {
        alert('Error: ' + res.data.status);
      }
    } catch (error) {
      console.error('Error in updating location:', error);
    }
  };

  const checkAndDeactivateUser = async () => {
    try {
      const checkResponse = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/auth/check-email-in-users?email=${values.email}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (checkResponse.data.exists) {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/auth/deactivate`,
          { email: values.email },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        fetchUserLoginData(values.email);
      }
    } catch (error) {
      console.error('Error in checking email existence or deactivating user:', error);
    }
  };

  const checkAndActivateUser = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/activate`,
        {
          name: values.location_name,
          email: values.email,
          role: 'locatie_admin',
          form_customer_id: values.customer_id,
          form_location_ids: id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.Status === 'Success') {
        fetchUserLoginData(values.email);
      } else {
        alert('Mogelijk is er iets misgegaan');
      }
    } catch (error) {
      console.error('Error in registerOrActivateUser:', error);
    }
  };

  const handleCancel = () => {
    navigate('/locaties');
  };

  return (
    <div className="all-locatie">
      {isLoading ? (
        <div className="text-center">Gegevens worden geladen...</div>
      ) : !values || Object.keys(values).length === 0 ? (
        <div className="text-center">Geen locatiegegevens gevonden.</div>
      ) : (
        <div className="bg-white p-4">
          <h2 className="text-center">Locatie Bewerken</h2>
          <hr className="seperator" />

          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="mb-3 col">
                <button
                  type="button"
                  className="btn btn-secondary w-50 rounded-0"
                  onClick={checkAndActivateUser}
                >
                  Enable inlog
                </button>
              </div>

              <div className="mb-3 col">
                <button
                  type="button"
                  className="btn btn-secondary w-50 rounded-0"
                  onClick={checkAndDeactivateUser}
                >
                  Disable inlog
                </button>
              </div>
            </div>

            <div className="mb-3 col">
              <p>Status: {userStatus ? userStatus : 'Loading...'}</p>
              <p>Role: {userRole ? userRole : 'Loading...'}</p>
            </div>

            <div className="mb-3">
              <label>Naam Locatie *</label>
              <input
                type="text"
                className="form-control rounded-0"
                required
                value={values?.location_name || ''}
                onChange={(e) => setValues({ ...values, location_name: e.target.value })}
              />
            </div>

            <div className="row">
              <div className="mb-3 col">
                <label>
                  Voornaam Contactpersoon<span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control rounded-0"
                  value={values?.contact_firstname || ''}
                  required
                  onChange={(e) =>
                    setValues({ ...values, contact_firstname: e.target.value })
                  }
                />
              </div>

              <div className="mb-3 col">
                <label>
                  Achternaam Contactpersoon<span style={{ color: 'red' }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control rounded-0"
                  value={values?.contact_lastname || ''}
                  required
                  onChange={(e) =>
                    setValues({ ...values, contact_lastname: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="row">
              <div className="mb-3 col">
                <label>Email *</label>
                <input
                  type="email"
                  className="form-control rounded-0"
                  required
                  value={values?.email || ''}
                  onChange={(e) => setValues({ ...values, email: e.target.value })}
                  onBlur={handleEmailBlur}
                  onFocus={() => setEmailExists(false)}
                />
                {emailExists && (
                  <div style={{ color: 'red' }}>Dit e-mailadres is al in gebruik.</div>
                )}
              </div>

              <div className="mb-3 col">
                <label>Mobiel Contactpersoon</label>
                <input
                  type="text"
                  className="form-control rounded-0"
                  value={values?.contact_mobile || ''}
                  onChange={(e) =>
                    setValues({ ...values, contact_mobile: e.target.value })
                  }
                />
              </div>
            </div>

            <div className="row">
              <div className="mb-3 col">
                <label>Telefoonnummer Locatie</label>
                <input
                  type="text"
                  className="form-control rounded-0"
                  value={values?.phone || ''}
                  onChange={(e) => setValues({ ...values, phone: e.target.value })}
                />
              </div>

              <div className="mb-3 col">
                <label>Volledig Adres</label>
                <input
                  type="text"
                  className="form-control rounded-0"
                  value={values?.address || ''}
                  onChange={(e) => setValues({ ...values, address: e.target.value })}
                />
              </div>
            </div>

            <hr className="seperator" />

            <div className="row">
              <div className="col-md-4">
                <button
                  type="button"
                  className="btn btn-secondary w-100 rounded-0"
                  onClick={handleCancel}
                >
                  Annuleren
                </button>
              </div>

              <div className="col-md-4">
                <button type="submit" className="btn btn-secondary w-100 rounded-0">
                  Opslaan
                </button>
              </div>
            </div>
          </form>

          <div className="spacer-bottom"></div>
        </div>
      )}
    </div>
  );
}

export default EditLocatie;